import {
    DOWNLOAD_RISKFACTOR_TEMPLATE_SUCCESS,
    DOWNLOAD_RISKFACTOR_TEMPLATE_FAILURE,
    UPLOAD_RISKFACTOR_TEMPLATE_SUCCESS,
    UPLOAD_RISKFACTOR_TEMPLATE_FAILURE,
} from './Search/action';
import { FETCH_RISKFACTOR_DETAILS_SUCCESS, FETCH_RISKFACTOR_DETAILS_FAILURE } from './View/action';
const initialState = {
    donwloadTemplateSuccess: null,
    downloadTemplateFailure: null,
    uploadTemplateSuccess: null,
    uploadTemplateFailure: null,
    fetchRiskFactorDetails: null,
    fetchRiskFactorDetailsFailure: null
}
const riskFactorReducer = (state = initialState, action) => {
    switch (action.type) {
        case DOWNLOAD_RISKFACTOR_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                donwloadTemplateSuccess: action.data
            }
        case DOWNLOAD_RISKFACTOR_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadTemplateFailure: action.data
            }
        case UPLOAD_RISKFACTOR_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                uploadTemplateSuccess: action.data
            }
        case UPLOAD_RISKFACTOR_TEMPLATE_FAILURE:
            return state = {
                ...state,
                uploadTemplateFailure: action.data
            }
        case FETCH_RISKFACTOR_DETAILS_SUCCESS:
            return state = {
                ...state,
                fetchRiskFactorDetails: action.data
            }
        case FETCH_RISKFACTOR_DETAILS_FAILURE:
            return state = {
                ...state,
                fetchRiskFactorDetailsFailure: action.data
            }
        default: return state
    }
}
export default riskFactorReducer;